import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import {
	createResource,
	type ResourceStoreContext,
	type RouterDataContext,
} from '@atlassian/react-resource-router';
import { memoizedFetchUserPersonalization } from '@atlassian/jira-personalization-service/src/services/user/index.tsx';
import { PACKAGE_NAME } from '../constants.tsx';
import { ANALYTICS_ID, RESOURCE_KEY, RESOURCE_TYPE } from './constants.tsx';
import type { PersonalizationApiTraitData, PersonalizationApiTraitDataResponse } from './types.tsx';

const getData = async (
	_: RouterDataContext,
	{ tenantContext }: ResourceStoreContext,
): Promise<PersonalizationApiTraitData[] | null> => {
	try {
		if (tenantContext.isAnonymous || !tenantContext.atlassianAccountId) {
			return null;
		}
		const accountId = tenantContext.atlassianAccountId;

		const ssrUrl = `/api/v3/personalization/user/${accountId}`;

		const response = __SERVER__
			? (
					await performGetRequest<PersonalizationApiTraitDataResponse>(ssrUrl, {
						headers: {
							'x-ssr-service-name': 'tap-delivery',
						},
					})
				)?.attributes
			: await memoizedFetchUserPersonalization({ userId: accountId });

		if (response) {
			return response;
		}

		return null;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			error,
			meta: {
				id: ANALYTICS_ID,
				packageName: PACKAGE_NAME,
			},
			sendToPrivacyUnsafeSplunk: true,
		});
	}
	return null;
};

export const fetchUserTraitsResource = createResource<PersonalizationApiTraitData[] | null>({
	type: RESOURCE_TYPE,
	getKey: () => RESOURCE_KEY,
	getData,
	maxAge: 0,
	isCritical: true,
});
